import React from 'react';
import { View } from 'react-native';
import ContentLoader from '../../../components/Common/LoadingComp/ContentLoader';
import RectLoader from '../../../components/Common/LoadingComp/RectLoader';

const FeedDetailsLoader = () => {
  return (
    <View style={{ paddingHorizontal: 60, marginTop: 60 }}>
      <ContentLoader speed={2} width={'100%'} height={600}>
        <RectLoader x='0' y='0' rx='8' ry='8' width='100%' height='600' />
      </ContentLoader>
    </View>
  );
};

export default FeedDetailsLoader;
